<template>
  <v-layout column wrap>
    <v-col lg12>
      <v-card>
        <yandex-map
          v-show="coords && coords.length > 0"
          style="height: 300px"
          :coords="coords"
          zoom="17"
        >
          <ymap-marker marker-type="placemark" marker-id="1" :coords="coords"></ymap-marker>
        </yandex-map>
        <v-card-text>
          <v-form name="siteInfo">
            <v-layout column wrap>
              <v-col cols="12">
                <v-switch
                  v-if="isEditor || isSuperuser"
                  v-model="siteData.publish_permission"
                  color="green"
                  name="publish_permission"
                  :label="`доступ для самостоятельно публикации новостей ${
                    siteData.publish_permission ? 'открыт' : 'закрыт'
                  }`"
                ></v-switch>
              </v-col>
              <v-col lg12>
                <v-text-field v-model="coords" label="Координаты" name="coordinates"></v-text-field>
                <input
                  type="text"
                  name="latitude"
                  v-model="siteData.latitude"
                  style="display: none"
                />
                <input
                  type="text"
                  name="longitude"
                  v-model="siteData.longitude"
                  style="display: none"
                />
                <input type="text" name="site_key" v-model="siteKey" style="display: none" />
              </v-col>
              <v-col lg12>
                <v-textarea v-model="siteData.address" label="Адрес" name="address"></v-textarea>
              </v-col>
              <v-col lg12>
                <v-text-field
                  v-model="siteData.work_time"
                  label="Время работы"
                  name="work_time"
                ></v-text-field>
              </v-col>
              <v-col lg12>
                <v-text-field
                  v-model="siteData.reception_time"
                  label="Время приема"
                  name="reception_time"
                ></v-text-field>
              </v-col>
              <v-col lg12>
                <v-text-field
                  v-model="siteData.email"
                  type="email"
                  label="Email"
                  name="email"
                ></v-text-field>
              </v-col>
              <v-col lg12>
                <v-text-field
                  v-model="siteData.phone_number"
                  label="Телефон"
                  name="phone_number"
                ></v-text-field>
              </v-col>
              <v-col lg12>
                <v-text-field
                  v-model="siteData.actual_video_id"
                  label="Актуальное видео (Прямой эфир)"
                  placeholder="Только id YouTube видео, вида JzJvoUYut98"
                  hint="Только id YouTube видео, вида JzJvoUYut98"
                  name="actual_video_id"
                >
                </v-text-field>
                <youtube
                  v-if="siteData.actual_video_id"
                  :video-id="siteData.actual_video_id"
                  player-width="100%"
                  player-height="500px"
                  :player-vars="{ showinfo: 0, frameborder: 0, rel: 0 }"
                >
                </youtube>
              </v-col>
              <v-col v-for="(v, k) in mdiMap" :key="v">
                <v-text-field :label="k" v-model="social[k]">
                  <template v-slot:prepend>
                    <v-icon :color="mdiMapColor[k]">{{ mdiMap[k] }}</v-icon>
                  </template>
                  <template v-slot:append v-if="social[k]">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn icon>
                          <v-icon @click="removeButton(k)" color="error" v-on="on">
                            mdi-close
                          </v-icon>
                        </v-btn>
                      </template>
                      удалить запись
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
            </v-layout>
            <v-btn @click="updateInfo" color="primary">Сохранить</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-layout>
</template>

<script>
import user from '@/mixins/user'

export default {
  name: 'Site',
  mixins: [user],
  props: { siteKey: { type: String, default: '' } },
  data() {
    return {
      siteData: {},
      social: {
        Вконтакте: '',
        // Facebook: '',
        YouTube: '',
        // Twitter: '',
        Telegram: '',
        Одноклассники: '',
        // Instagram: '',
      },
    }
  },
  computed: {
    coords: {
      get() {
        return Object.prototype.hasOwnProperty.call(this.siteData, 'longitude')
          ? [this.siteData.latitude, this.siteData.longitude]
          : []
      },
      set(el) {
        this.siteData.latitude = el.split(',')[0]
        this.siteData.longitude = el.split(',')[1]
      },
    },
  },
  watch: {
    siteKey() {
      this.updateData()
    },
  },
  mounted() {
    this.updateData()
  },
  methods: {
    updateData() {
      if (!this.siteKey) {
        return
      }
      this.axios({
        url: `/v1/info/${this.siteKey}`,
        method: 'get',
      })
        .then((resp) => {
          this.siteData = resp.data
          this.social = {}
          for (let k of this.siteData.social_buttons || []) {
            if (!Object.prototype.hasOwnProperty.call(this.mdiMap, k.kind)) {
              continue
            }
            this.$set(this.social, k.kind, k.url)
            // this.social[k.kind] = k.url
          }
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateInfo() {
      this.siteData.social_buttons = []
      for (let k in this.social) {
        if (!this.social[k]) {
          continue
        }
        this.siteData.social_buttons.push({
          kind: k,
          url: this.social[k],
        })
      }
      // this.siteData.social_buttons = this.social
      this.axios({
        url: `/v1/info/${this.siteKey}`,
        method: 'patch',
        data: this.siteData,
      })
        .then((resp) => {
          this.siteData = resp.data
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    removeButton(kind) {
      this.axios({
        url: `/v1/info/${this.siteKey}/${kind}`,
        method: 'delete',
      })
        .then((resp) => {
          this.$log.debug('before', kind, this.social[kind])
          this.social[kind] = ''
          this.$set(this.social, kind, '')
          this.$log.debug('before-2', kind, this.social[kind])
          this.showSnackbar('Ссылка удалена', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>
